import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LandingNav from "@/components/LandingNav";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowRight } from "lucide-react";
import { featurePages } from "@/content/featurePages";

const FeaturesIndex = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <SEOHead
        title={t(
          "features.indexMetaTitle",
          "Features — Android Autofill, Chrome Extension, Desktop & API | TestAssets",
        )}
        description={t(
          "features.indexMetaDescription",
          "Every way to use TestAssets: Android autofill, Chrome extension, desktop quick paste, REST API, and MCP server for AI agents.",
        )}
        path="/features"
        breadcrumbs={[
          { name: t("nav.start"), url: "/" },
          { name: t("features.indexTitle", "Features"), url: "/features" },
        ]}
      />
      <LandingNav />
      <main className="flex-1 container mx-auto px-6 py-16 max-w-5xl">
        <header className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
            {t("features.indexTitle", "Features")}
          </h1>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            {t(
              "features.indexSubtitle",
              "Every surface where TestAssets puts your test data within reach.",
            )}
          </p>
        </header>
        <div className="grid gap-6 md:grid-cols-2">
          {featurePages.map((p) => {
            const Icon = p.icon;
            return (
              <Link key={p.slug} to={`/features/${p.slug}`} className="group">
                <Card className="h-full transition-colors hover:border-primary/50">
                  <CardHeader>
                    <div className="flex items-center gap-3 mb-2">
                      <div className="h-10 w-10 rounded-lg bg-primary/10 text-primary flex items-center justify-center">
                        <Icon className="h-5 w-5" />
                      </div>
                      <CardTitle className="text-xl group-hover:text-primary transition-colors">
                        {p.h1}
                      </CardTitle>
                    </div>
                    <CardDescription>{p.intro}</CardDescription>
                  </CardHeader>
                  <CardContent className="text-sm text-primary inline-flex items-center gap-1">
                    {t("features.learnMore", "Learn more")}
                    <ArrowRight className="h-4 w-4" />
                  </CardContent>
                </Card>
              </Link>
            );
          })}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default FeaturesIndex;